module.exports = __webpack_public_path__ + "static/media/caic.475d35af.png";